import React, { useEffect, useContext } from 'react';
import { isTablet } from 'utils/common';
import makeRequest from 'utils/makeRequest';
//import PropTypes from 'prop-types';
import useMergeState from 'utils/hooks/useMergeState';
import InViewObserver from 'components/InViewObserver';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import CardListV5 from 'components_v2/common/CardListV5';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import Listingheader from '../../common/ListingheaderV2';
import HeaderTab from '../HeaderTabV2';
import RenderAds from '../RenderAds';
import SmallList from './SmallList';
import s from './ThreeColLayout.scss';

const getLeadPlusVerticalList = (
  dataObj,
  index,
  sectionName,
  cardClass,
  ga4Type,
  ga4Category,
) => {
  const data = dataObj;
  const listItems = data.data || data.items || [];
  if (listItems instanceof Array) {
    return (
      <div className={`${'col_l_4 col_m_4'}`} key={`ls-${index}`}>
        <Listingheader
          headingLink={data.link || data.path}
          headingname={data.name}
          size="small"
          newga={`${sectionName}Section_Actions#HeadingClick-${data.name}`}
          target={data.target}
          ga4Category={data?.ga4Category ? data?.ga4Category : ga4Category}
          ga4Type={data?.ga4Type ? data?.ga4Type : ga4Type}
        />
        <CardListV5
          data={listItems}
          featuredItemDisplay={{
            cssObj: {
              figureClass: 'linktype2',
            },
            featuredIndex: 0,
            isLeadTypeTwo: true,
          }}
          nonFeaturedDisplay={{
            tileType: 'default',
            itemWrapperClass: `${s.entertainment}`,
            cssObj: {
              figureClass: 'linktype2',
            },
            hideImage: !!isTablet(),
            itemClass: isTablet() && 'linktype1',
            showDuration: false,
            showPhotosCount: false,
            cardClass,
          }}
          showDescription={false}
          newga={`${sectionName}Section_Actions#$typeClick-${
            data.name
          }-${index}`}
          imgWidth="500"
          ga4Category={data?.ga4Category ? data?.ga4Category : ga4Category}
          ga4Type={data?.ga4Type ? data?.ga4Type : ga4Type}
          gaIndex={index}
        />
      </div>
    );
  }
  return null;
};

const getLinkList = (dataObj, index, geoCityData, ga4Type, ga4Category) => {
  const data = dataObj;
  const listItems = data.data || data.items || [];
  if (listItems instanceof Array) {
    return (
      <SmallList
        dataObj={dataObj}
        index={index}
        geoCityData={geoCityData}
        ga4Category={data?.ga4Category ? data?.ga4Category : ga4Category}
        ga4Type={data?.ga4Type ? data?.ga4Type : ga4Type}
      />
    );
  }
  return null;
};

const getItems = (
  dataObj,
  index,
  geoCityData,
  name,
  cardClass = '',
  ga4Type,
  ga4Category,
) => {
  let component;
  switch (dataObj.tn) {
    case 'lead_plus_vertical_list':
      component = getLeadPlusVerticalList(
        dataObj,
        index,
        name,
        cardClass,
        ga4Type,
        ga4Category,
      );
      break;
    case 'list':
      component = getLinkList(
        dataObj,
        index,
        geoCityData,
        ga4Type,
        ga4Category,
      );
      break;
    case 'column_1_list':
      component = getLinkList(
        dataObj,
        index,
        geoCityData,
        ga4Type,
        ga4Category,
      );
      break;
    default:
      component = null;
      break;
  }
  return component;
};

const ThreeColLayout = props => {
  let listItems;
  const { sectionData, geoCityData, cardClass } = props;
  const ga4Category = sectionData?.ga4Category ? sectionData?.ga4Category : '';
  const ga4Type = sectionData?.ga4Type ? sectionData?.ga4Type : '';
  const wrapperClass = props.wrapperClass ? props.wrapperClass : '';
  const scrollGAAttr = {
    ...((sectionData.onScrollGA ||
      sectionData.id === 'al_multisec_seo_widget') &&
      sectionData.id && {
        'data-scrollga':
          sectionData.id === 'al_multisec_seo_widget'
            ? 'View_SEO widget'
            : sectionData.id,
      }),
  };
  const [state, updateState] = useMergeState({
    headerItemsState: [],
    loading: false,
    ajaxCall: false,
    itemsState: null,
  });
  const userContext = useContext(UserPreferenceContext);
  const headerTabs = state.headerItemsState;

  if (state.ajaxCall) {
    listItems = state.itemsState;
  } else {
    listItems = sectionData.items || state.itemsState;
  }

  const loadHeaderData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data?.data?.items?.length > 0) {
        //console.log('data : ', data.data);
        updateState({ headerItemsState: data.data.items });
      }
    });
  };

  const loadSectionData = (dataUrl, isAjaxCall) => {
    if (!dataUrl) {
      return;
    }
    updateState({ loading: true });
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data?.data?.items?.length > 0) {
        //console.log('data : ', data.data);
        updateState({ itemsState: data.data.items });
      }
      updateState({ ajaxCall: !!isAjaxCall });
      updateState({ loading: false });
    });
  };

  const loadDataFromLang = lang => {
    if (!(headerTabs instanceof Array && typeof lang === 'string')) {
      return;
    }

    const filtered = headerTabs.filter(node => {
      const name =
        typeof node?.name === 'string' ? node.name.toLowerCase() : '';
      return name === lang.toLowerCase();
    });
    loadSectionData(filtered[0]?.dataUrl, true);
  };

  // useEffect(() => {
  //   if (sectionData?.subSections?.dataUrl) {
  //     loadHeaderData(sectionData.subSections.dataUrl);
  //   }
  //   return () => {
  //     //~unmount
  //   };
  // }, []);

  const loadNavigationData = () => {
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      loadHeaderData(sectionData.subSections.dataUrl);
    }
  };

  useEffect(
    () => {
      loadDataFromLang(userContext.geoLang);
      return () => {
        //~unmount
      };
    },
    [userContext.geoLang, headerTabs],
  );

  const onTabsChange = params => {
    if (params?.clickedItem?.dataUrl) {
      loadSectionData(params.clickedItem.dataUrl, true);
    }
  };

  return (
    <InViewObserver
      inViewCallback={() => {
        loadNavigationData();
      }}
      viewMargin="300px 0px 300px 0px"
    >
      <div className={s.wrapper} {...scrollGAAttr}>
        {state.loading && <LoaderSpinner />}
        {sectionData.border &&
          sectionData.border === 'top' && (
            <InterSectionBorder border={sectionData.border} />
          )}
        {sectionData &&
          sectionData.name && (
            <Listingheader
              headingname={sectionData.name}
              headingLink={sectionData.link || sectionData.path}
              subheading={sectionData.subHeading}
              newga={`${sectionData.name}Section_Actions#HeadingClick`}
              target={sectionData.target}
              ga4Type={ga4Type}
              ga4Category={ga4Category}
            >
              {headerTabs && headerTabs instanceof Array ? (
                <HeaderTab
                  subSections={headerTabs}
                  active={userContext.geoLang}
                  onChangeCallback={onTabsChange}
                  newga={`${sectionData.name}Section_Actions_TabChange#Click_`}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                />
              ) : null}
            </Listingheader>
          )}
        <div className={`${'grid_wrapper'} ${s[wrapperClass]}`}>
          {listItems instanceof Array &&
            listItems.map((item, index) =>
              getItems(
                item,
                index,
                geoCityData,
                sectionData.name,
                cardClass,
                ga4Type,
                ga4Category,
              ),
            )}
          {sectionData.inserts && sectionData.inserts.length > 0 ? (
            <div className="col_l_4 col_m_6">
              <RenderAds adObject={sectionData.inserts[0]} />
            </div>
          ) : null}
        </div>
      </div>
    </InViewObserver>
  );
};

export default ThreeColLayout;
